// @flow
import React, { Component } from "react";
import Scrollchor from "react-scrollchor";

export class ScrollToTopOnMount extends Component<{}> {
  _back: null;

  constructor(props) {
    super(props);

    this.state = {
      to: this.props.location.hash.length
        ? this.props.location.hash.replace("#", "")
        : "main-content"
    };
  }

  componentDidMount() {
    if (this._back !== null) this._back.simulateClick();
  }

  componentDidUpdate() {
    if (this._back !== null) this._back.simulateClick();
  }

  componentWillUnmount() {
    this._back = null;
  }

  render() {
    return (
      <Scrollchor
        animate={{ duration: 0 }}
        ref={ref => (this._back = ref)}
        to={this.state.to}
        disableHistory
      />
    );
  }
}

export default ScrollToTopOnMount;
